export enum ImageSourceType {
    Static = 1,
    Dynamic = 2
}

export enum ImageLabelType {
    TextArrow = 1,
    StickyArrow = 2,
    Box = 4,
    Region = 6
}

export type ImageFavoriteSize = 'Small' | 'Medium' | 'Large';

// Codes match the API's SensorReadingAggregator ('last' = most recent reading).
export const ImageLabelAggregations = [
    { value: 'last', label: 'Last value' },
    { value: 'avg', label: 'Average' },
    { value: 'med', label: 'Median' },
    { value: 'min', label: 'Minimum' },
    { value: 'max', label: 'Maximum' },
    { value: 'cnt', label: 'Count' },
    { value: 'sum', label: 'Sum' }
];
